export const constantsMap = {
    see: 'SEE',
    reserve: 'RESERVE',
    home: 'HOME',
    showroom: 'SHOWROOM',
    atHome :'At Home ',
    atSylndrHub : 'At Sylndr Hub'
};

export enum CheckoutSteps {
    'PAYMENT_STEP' = 4,
}
